// Stable per-device UUID. Generated on first use and stored in
// localStorage so the same value rides every auth call from this
// browser profile. The auth backend uses it to identify a session and
// enforce the per-user MaxSessions cap (a hard cap: past the limit the
// new sign-in is rejected with DEVICE_LIMIT_EXCEEDED, never auto-evict;
// the user frees a slot by revoking from an already-signed-in device).

import { newUUID } from './uuid';

const DEVICE_ID_KEY = 'app.device.id';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing && UUID_RE.test(existing)) return existing;
    const fresh = newUUID();
    localStorage.setItem(DEVICE_ID_KEY, fresh);
    return fresh;
  } catch {
    // Private mode / storage disabled: fall back to a session-scoped
    // UUID. Auth flows still work; the session just won't be recognized
    // as the same device on the next page load.
    return newUUID();
  }
}
